 <template>
	<section class="section-wrapper">
		<base-container>
			<base-heading :heading="`${prefix}.section_title`" :subheading="`${prefix}.section_subtitle`"/>
		</base-container>

		<div class="wrapper">
			<grid-template cols="3">
					<div class="logos" v-for="(item, index) in value.logos" :key="index">
						<cms-image
							lazy
							:src="item.logo"
						/>
					</div>
			</grid-template>
		</div>
	</section>
</template>

<script>
import BaseHeading from '../../components/molecules/headings/BaseHeading/BaseHeading.vue'
import GridTemplate from '../../templates/GridTemplate.vue'
export default {
	components: {
		GridTemplate,
		BaseHeading
	},
	props: {
		prefix: String,
		value: Object
	}
}
</script>
<style lang="scss" scoped>
.section-wrapper {
	padding: 4rem 0;
    @include media-breakpoint-up(md) {
        padding: 4rem 0 2rem 0;
    }

	@include media-breakpoint-up(xxl) {
		padding-top: 0;
	}

	::v-deep(.heading-wrapper){
		@include media-breakpoint-up(xl){
			margin-bottom: 6rem;
		}

		.subheading{
			&:after, &:before {
				flex: auto;
				@include media-breakpoint-up(xl){
					flex: 1;
				}
			}
		}
	}
}
.wrapper {

	.logos {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 4rem 0;
		height: 100%;
		position: relative;

		@include media-breakpoint-up(xl) {
			padding: 6rem 0;
		}
		&::after {
			position: absolute;
			content: "";
			top: 0;
			left: 0;
			width: 100vw;
			height: .1rem;
			background-color: #E9E9E9;
		}

		::v-deep .base-image {
			display: block;
			max-width: 100%;
		}
	}
}

::v-deep .grid-wrapper {
	overflow: hidden;
	gap: 0 5rem;
}
</style>
